import { takeEvery, put, call } from 'redux-saga/effects';
import type { SagaReturnType } from 'redux-saga/effects';
import { documentBundleActions } from 'src/redux/actions/constant';
import documentBundleService from 'src/services/apiServices/document-bundle/document-bundle-service';
import { DownloadJob } from 'src/sections/reports/downloads/mock-data';

const {
  REQUEST_GET_DOWNLOAD_JOBS,
  SUCCESS_GET_DOWNLOAD_JOBS,
  FAILURE_GET_DOWNLOAD_JOBS,
  LOADING_GET_DOWNLOAD_JOBS,
} = documentBundleActions;

function mapRequestDetails(raw: any) {
  if (!raw) return undefined;
  // If already in nested format (from ReArchive), pass through as-is
  if (raw.filters_applied) return raw;
  // Legacy flat format (from old local DB) — restructure into nested
  return {
    filters_applied: {
      date_from: raw.date_from ?? raw.dateFrom,
      date_to: raw.date_to ?? raw.dateTo,
      payer_type: raw.payer_type ?? raw.payerType,
      payer_name: raw.payer_name ?? raw.payerName,
      discipline: raw.discipline,
      doc_type: raw.doc_type ?? raw.docType,
      patient_ids: raw.patient_ids ?? raw.patientIds,
    },
    file_organization: {
      date_scope: raw.date_scope ?? raw.dateScope,
      group_by: raw.group_by ?? raw.groupBy,
      document_handling: raw.document_handling ?? raw.documentHandling,
      order_by: raw.order_by ?? raw.orderBy,
    },
  };
}

function mapJob(j: any): DownloadJob {
  return {
    job_id: j.jobId,
    job_name: j.jobName,
    status: j.status,
    progress_pct: j.progressPct ?? 0,
    created_at: j.createdAt,
    completed_at: j.completedAt,
    document_count: j.documentCount ?? 0,
    patient_count: j.patientCount ?? 0,
    size_bytes: j.sizeBytes,
    request_details: mapRequestDetails(j.requestDetails),
  };
}

function* getDownloadJobs(): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_GET_DOWNLOAD_JOBS });
    const response = yield call(documentBundleService.getDownloadJobs);
    if (response?.status === 200) {
      const jobs: DownloadJob[] = (response.data?.data ?? []).map(mapJob);
      yield put({ type: SUCCESS_GET_DOWNLOAD_JOBS, payload: jobs });
    } else {
      throw response?.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_DOWNLOAD_JOBS, payload: error });
  }
}

function* getDownloadJobsSaga() {
  yield takeEvery(REQUEST_GET_DOWNLOAD_JOBS, getDownloadJobs);
}

export default getDownloadJobsSaga;
export { getDownloadJobs };
